
(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.slider = {
    initMyTripArticleSlider: function () {
      var myTrip = $('.view-id-mytrip.view-display-id-articles .view-content');
      var url = window.location.href;
      var me = Drupal.blazy;

      if (myTrip.length && !url.includes('my-trip-print')) {
        myTrip.each(function () {
          if ($(this).find('.views-row').length > 3) {
            $(this).slick({
              arrows: false,
              centerMode: true,
              infinite: false,
              mobileFirst: true,
              slidesToShow: 1,
              useCss: false,
              variableWidth: true,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    arrows: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true
                  }
                }
              ]
            });

            $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
            });
            $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
              me.init.revalidate();
              setTimeout(() => { // eslint-disable-line  max-nested-callbacks
                $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
                $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
              }, 300);
            });
          }
        });


        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      }
    },
    initTrailSlider: function () {
      var selectedTrail = $('.view-related-trails .view-content, .view-id-mytrip.view-display-id-trails .view-content');
      var me = Drupal.blazy;
      if (selectedTrail.length) {
        selectedTrail.each(function () {
          $(this).slick({
            slidesToShow: 1,
            arrows: true,
            infinite: true,
            dots: true,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  adaptiveHeight: true,
                  dots: false
                }
              }
            ]
          });
          $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
            $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
          });
          $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            me.init.revalidate();
            setTimeout(() => {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
            }, 300);
          });
        });


        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      }
    },
    attach: function (context) {
      var selectedPartner = $(once('slick-slider', '.section.slider .field--name-field-slider-images', context));
      var ImageSliderParagraph = $(once('slick-slider', '.component-image-slider .field--name-field-image-slides', context));
      var selectedPartnerPara = $(once('slick-slider', '.section.slider .field--name-field-image-slides.slider-enabled', context));
      var selectedTeaserCard = $(once('slick-slider', '.field--name-field-teaser-card-para', context));
      var selectedExperience = $(once('slick-slider', '.view-id-experience_teasers.view-display-id-block_2 .view-content', context));
      var selectedArticle = $(once('slick-slider', '.view-id-article_teasers .view-content', context));
      var selectedArticleListing = $(once('slick-slider', '.view-id-article_listings.view-display-id-trending .view-content', context));
      var featuredArticleListing = $(once('slick-slider', '.paragraph-item--featured-articles-listing .field__items', context));
      var selectedGrouping = $(once('slick-slider', '.grouped-content', context));
      var itineraryStop = $(once('slick-slider', '.itinerary-stop .itinerary-img .amp-carousel', context));
      var contentSlider = $(once('slick-slider', '.component-content-slider .field__items', context));
      var contentPodSlider = $(once('slick-slider', '.component-content-pod--content-pod-slider .component-content-pod__content', context));
      var me = Drupal.blazy;
      var el = context.querySelector('[data-blazy]');
      if (el === null) {
        me.init = new Blazy(me.globals()); // eslint-disable-line no-undef
      }

      // Bind init event listener function
      $(selectedPartner).on('init', function (event, slick) {
        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      });

      $(ImageSliderParagraph).on('init', function (event, slick) {
        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      });

      $(selectedPartnerPara).on('init', function (event, slick) {
        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      });
      $(selectedTeaserCard).on('init', function (event, slick) {
        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      });

      $(selectedExperience).on('init', function (event, slick) {
        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      });

      $(selectedArticle).on('init', function (event, slick) {
        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      });

      $(selectedArticleListing).on('init', function (event, slick) {
        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      });

      $(featuredArticleListing).on('init', function (event, slick) {
        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      });

      $(selectedGrouping).on('init', function (event, slick) {
        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      });

      $(itineraryStop).on('init', function (event, slick) {
        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      });

      $(contentSlider).on('init', function (event, slick) {
        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      });

      $(contentPodSlider).on('init', function (event, slick) {
        $('.slick-current a').attr('tabindex', '0');
        $('.slick-current button').attr('tabindex', '0');
      });


      var slideStart;
      Drupal.behaviors.slider.initMyTripArticleSlider(context);
      Drupal.behaviors.slider.initTrailSlider(context);

      if (selectedPartner.length) {
        selectedPartner.each(function () {
          $(this).slick({
            slidesToShow: 1,
            variableWidth: true,
            useCss: false,
            arrows: true,
            prevArrow: '',
            nextArrow: '<div class="slick-next"><img class="b-lazy" data-src="/themes/custom/tnvacation/img/slider-next.png" alt="Slider Next Arrow"></div>',
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  centerMode: true
                }
              }
            ]
          });
          $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.slick-current a').attr('tabindex', '-1');
            $('.slick-current button').attr('tabindex', '-1');
          });
          $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            var asset = location.href;
            dataLayer.push({eventCategory: 'slider-partner', eventAction: 'click', eventLabel: asset, eventvalue: '', event: 'eventClick'}); // eslint-disable-line no-undef
            me.init.revalidate();
            setTimeout(() => {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
            }, 300);
          });
        });
      }

      if (ImageSliderParagraph.length) {
        ImageSliderParagraph.each(function () {
          $(this).slick({
            slidesToShow: 1,
            variableWidth: true,
            useCss: false,
            arrows: true,
            prevArrow: '<div class="slick-prev"><img class="b-lazy" data-src="/themes/custom/tnvacation/img/slider-prev.png" alt="Slider Previous Arrow"></div>',
            nextArrow: '<div class="slick-next"><img class="b-lazy" data-src="/themes/custom/tnvacation/img/slider-next.png" alt="Slider Next Arrow"></div>',
            centerMode: true
          });
          $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
            $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
          });
          $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            setTimeout(() => {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
            }, 300);
          });
        });
      }

      if (selectedPartnerPara.length) {
        selectedPartnerPara.each(function () {
          $(this).slick({
            slidesToShow: 1,
            variableWidth: true,
            useCss: false,
            arrows: true,
            prevArrow: '<div class="slick-prev"><img class="b-lazy" data-src="/themes/custom/tnvacation/img/slider-prev.png" alt="Slider Previous Arrow"></div>',
            nextArrow: '<div class="slick-next"><img class="b-lazy" data-src="/themes/custom/tnvacation/img/slider-next.png" alt="Slider Next Arrow"></div>',
            centerMode: true
          });
          $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
            $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
          });
          $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            var asset = location.href;
            if (document.body.classList.contains('bill-dance-signature-lakes')) {
              dataLayer.push({
                eventCategory: 'slider',
                eventAction: 'click',
                eventLabel: asset,
                eventvalue: '',
                event: 'eventClick'
              }); // eslint-disable-line no-undef
            }
            else {
              dataLayer.push({
                eventCategory: 'slider-partner',
                eventAction: 'click',
                eventLabel: asset,
                eventvalue: '',
                event: 'eventClick'
              }); // eslint-disable-line no-undef
            }
            me.init.revalidate();
            setTimeout(() => {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
            }, 300);
          });
        });
      }

      if (selectedTeaserCard.length) {

        selectedTeaserCard.each(function () {
          $(this).slick({
            useCss: true,
            arrows: true,
            infinite: false,
            variableWidth: true,
            centerMode: true,
            centerPadding: '8px',
            accessibility: false,
            focusOnSelect: true
          });
          var slideCount = $(this).slick('getSlick').slideCount;
          slideStart = Math.round(slideCount / 2 - 1);
          $(this).slick('slickGoTo', slideStart).addClass('stacked');
          $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
            $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
          });
          $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            me.init.revalidate();
            setTimeout(() => {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
            }, 300);
          });
        });
      }

      if (selectedExperience.length) {
        selectedExperience.each(function () {
          $(this).slick({
            useCss: true,
            arrows: true,
            dots: true,
            infinite: true,
            centerMode: true,
            centerPadding: '15px',
            variableWidth: true,
            slidesToShow: 1,
            accessibility: false,
            focusOnSelect: true,
            appendDots: '.view-experience-teasers .slick-dot-nav',
            prevArrow: $('.view-experience-teasers .view-footer .prev'),
            nextArrow: $('.view-experience-teasers .view-footer .next')
          });
          var slideCount = $(this).slick('getSlick').slideCount;
          slideStart = Math.round(slideCount / 2 - 1);
          $(this).slick('slickGoTo', slideStart);
          $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
            $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
          });
          $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            me.init.revalidate();
            setTimeout(() => {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
            }, 300);
          });
        });

      }

      if (selectedArticle.length) {
        selectedArticle.each(function () {
          $(this).slick({
            useCss: true,
            arrows: true,
            dots: true,
            infinite: true,
            centerMode: true,
            centerPadding: '15px',
            variableWidth: true,
            slidesToShow: 1,
            accessibility: false,
            focusOnSelect: true,
            appendDots: '.view-article-teasers .view-footer .slick-dot-nav',
            prevArrow: $('.view-article-teasers .view-footer .prev'),
            nextArrow: $('.view-article-teasers .view-footer .next')
          });
          var slideCount = $(this).slick('getSlick').slideCount;
          slideStart = Math.round(slideCount / 2 - 1);
          $(this).slick('slickGoTo', slideStart);
          $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
            $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
          });
          $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            me.init.revalidate();
            setTimeout(() => {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
            }, 300);
          });
        });

      }

      if (selectedArticleListing.length) {

        selectedArticleListing.each(function () {
          $(this).slick({
            useCss: true,
            arrows: true,
            dots: true,
            infinite: true,
            centerMode: true,
            centerPadding: '15px',
            variableWidth: true,
            slidesToShow: 1,
            accessibility: false,
            focusOnSelect: true,
            appendDots: $('.view-id-article_listings.view-display-id-trending .view-footer .slick-dot-nav'),
            prevArrow: $('.view-id-article_listings.view-display-id-trending .view-footer .prev'),
            nextArrow: $('.view-id-article_listings.view-display-id-trending .view-footer .next')
          });
          var slideCount = $(this).slick('getSlick').slideCount;
          slideStart = Math.round(slideCount / 2 - 1);
          $(this).slick('slickGoTo', slideStart);
          $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
            $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
          });
          $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            me.init.revalidate();
            setTimeout(() => {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
            }, 300);
          });
        });

      }

      if (selectedGrouping.length) {
        selectedGrouping.each(function () {
          var slideNum = $(this).children().length;
          $(this).parent('.content-grouping-container').addClass('content-group--' + (slideNum < 4 ? slideNum : 4));
          $(this).slick({
            arrows: false,
            dots: true,
            centerMode: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            useCss: false,
            variableWidth: true,
            responsive: [
              {
                breakpoint: 1300,
                settings: {
                  arrows: true,
                  dots: false,
                  centerMode: false,
                  slidesToShow: slideNum < 4 ? slideNum : 4
                }
              },
              {
                breakpoint: 1200,
                settings: {
                  arrows: true,
                  dots: false,
                  centerMode: false,
                  slidesToShow: 3
                }
              }
            ]
          });
          $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
            $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
          });
          $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            me.init.revalidate();
            setTimeout(() => {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
            }, 300);
          });
        });
      }

      if (itineraryStop.length) {
        itineraryStop.each(function () {
          if ($(this).find('.itinerary-img-item').length > 1) {
            $(this).slick({
              slidesToShow: 1,
              arrows: true,
              infinite: true,
              dots: false,
              slide: '.itinerary-img-item',
              responsive: [
                {
                  breakpoint: 610,
                  settings: {
                    arrows: false,
                    dots: true
                  }
                }
              ]
            });
            $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
            });
            $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
              me.init.revalidate();
              setTimeout(() => {
                $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
                $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
              }, 300);
            });
          }
        });
      }

      if (featuredArticleListing.length) {
        featuredArticleListing.each(function () {
          if ($(this).find('.field__item').length > 1) {
            $(this).slick({
              slidesToShow: 1,
              arrows: false,
              infinite: true,
              dots: true,
              slide: '.field__item',
              mobileFirst: true,
              variableWidth: true,
              responsive: [
                {
                  breakpoint: 768,
                  settings: 'unslick'
                }
              ]
            });
            $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
            });
            $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
              me.init.revalidate();
              setTimeout(() => {
                $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
                $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
              }, 300);
            });
          }
        });
      }

      if (contentSlider.length) {
        contentSlider.each(function () {
          $(this).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            centerMode: true,
            variableWidth: false,
            useCss: false,
            arrows: true,
            dots: true,
            responsive: [
              {
                breakpoint: 1330,
                settings: {
                  autoplay: false,
                  slidesToShow: 7,
                  dots: false,
                  centerMode: false
                }
              },
              {
                breakpoint: 1050,
                settings: {
                  autoplay: false,
                  slidesToShow: 5,
                  dots: false,
                  centerMode: false
                }
              },
              {
                breakpoint: 960,
                settings: {
                  autoplay: false,
                  slidesToShow: 3,
                  dots: false,
                  centerMode: false
                }
              },
              {
                breakpoint: 640,
                settings: {
                  autoplay: false,
                  slidesToShow: 2,
                  dots: false,
                  centerMode: false
                }
              }
            ]
          });
          var slideCount = $(this).slick('getSlick').slideCount;
          slideStart = Math.round(slideCount / 2 - 1);
          $(this).slick('slickGoTo', slideStart).addClass('centered');
          $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
            $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
          });
          $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            me.init.revalidate();
            setTimeout(() => {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
            }, 300);
          });
        });
      }

      if (contentPodSlider.length) {
        contentPodSlider.each(function () {
          $(this).slick({
            useCss: true,
            arrows: true,
            dots: true,
            infinite: true,
            centerMode: true,
            centerPadding: '15px',
            variableWidth: true,
            slidesToShow: 1,
            accessibility: false,
            focusOnSelect: true,
            appendDots: '.content-pod-slick-dot-nav',
            prevArrow: $('.component-content-pod--content-pod-slider .view-content-pod-footer .prev'),
            nextArrow: $('.component-content-pod--content-pod-slider .view-content-pod-footer .next')
          });
          var slideCount = $(this).slick('getSlick').slideCount;
          slideStart = Math.round(slideCount / 2 - 1);
          $(this).slick('slickGoTo', slideStart);
          $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '-1');
            $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '-1');
          });
          $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            me.init.revalidate();
            setTimeout(() => {
              $(slick.$slides.get(currentSlide)).find('a').attr('tabindex', '0');
              $(slick.$slides.get(currentSlide)).find('button').attr('tabindex', '0');
            }, 300);
          });
        });
      }
    }
  };
})(jQuery, Drupal, once, dBlazy); // eslint-disable-line no-undef
